module.exports = __webpack_public_path__ + "img/phones.2f59d21f.png";